import React from 'react';
import styled from 'styled-components';

const BuyButton = ({ onClick }) => {
  return (
    <StyledWrapper>
      <button className="btn" onClick={onClick}>Shop now</button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
  .btn {
    width: 100%;
    max-width: 731px; /* O el ancho que desees */
    min-width: 200px;
    margin: 0 auto;
    display: block;
    padding: 1.1em 2em;
    background: none;
    border: 2px solid #fff;
    font-size: 15px;
    color: #131313;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s;
    border-radius: 12px;
    background-color: gray;
    font-weight: bolder;
    box-shadow: 0 2px 0 2px #000;
    height: 60px;
  }
  .btn:before {
    content: "";
    position: absolute;
    width: 100px;
    height: 120%;
    background-color: #F0F0EC;
    top: 50%;
    left: 0;
    transform: skewX(30deg) translate(-150%, -50%);
    transition: all 0.5s;
    pointer-events: none;
    z-index: 1;
  }
  .btn:hover {
    background-color: yellow;
    color: #fff;
    box-shadow: 0 2px 0 2px #0d3b66;
  }
  .btn:hover::before {
    transform: skewX(30deg) translate(150%, -50%);
    transition-delay: 0.1s;
  }
  .btn:active {
    transform: scale(0.98);
  }
`;

export default BuyButton;
